var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          staticClass: "mt-1",
          attrs: { variant: "primary" },
          on: {
            click: function ($event) {
              _vm.isModalOpen = true
            },
          },
        },
        [_vm._v("\n        Dienstleisteraktion protokollieren\n    ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "clear" }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "cancel-disabled": _vm.isLoading,
            "cancel-title": "Abbrechen",
            "no-close-on-backdrop": _vm.isLoading,
            "no-close-on-esc": _vm.isLoading,
            "ok-disabled": _vm.isLoading,
            "ok-title": "Speichern",
            size: "xl",
            title: "Dienstleisteraktion protokollieren",
          },
          on: {
            hidden: function ($event) {
              return _vm.reset()
            },
            ok: _vm.saveExternalServiceProviderAction,
            show: _vm.createExternalServiceProviderAction,
          },
          model: {
            value: _vm.isModalOpen,
            callback: function ($$v) {
              _vm.isModalOpen = $$v
            },
            expression: "isModalOpen",
          },
        },
        [
          _vm.isLoading
            ? _c(
                "div",
                { staticClass: "d-flex justify-content-center" },
                [_c("csp-loading-indicator")],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "csp-desktop-info-card",
                    {
                      staticClass: "editMode",
                      attrs: { cols: 12, icon: "inticon-users" },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-4",
                            attrs: {
                              "form-context": _vm.externalFormContext,
                              label: "Externer Dienstleister",
                              "options-loader":
                                _vm.loadExternalServiceProviderOptions,
                              property: "externalServiceProvider",
                              required: true,
                              type: "autocomplete",
                            },
                          }),
                          _vm._v(" "),
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-4",
                            attrs: {
                              dependencies: ["externalServiceProvider"],
                              "form-context": _vm.externalFormContext,
                              label: "Aktion",
                              "options-loader": _vm.loadServiceActionOptions,
                              property: "externalServiceAction",
                              required: true,
                              type: "autocomplete",
                            },
                          }),
                          _vm._v(" "),
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-4",
                            attrs: {
                              "form-context": _vm.externalFormContext,
                              label: "Datum",
                              property: "dateOfAction",
                              required: true,
                              type: "datepicker",
                            },
                          }),
                          _vm._v(" "),
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-4",
                            attrs: {
                              "form-context": _vm.externalFormContext,
                              label: "Vorname",
                              property: "firstName",
                              required: false,
                              type: "text",
                            },
                          }),
                          _vm._v(" "),
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-4",
                            attrs: {
                              "form-context": _vm.externalFormContext,
                              label: "Nachname",
                              property: "lastName",
                              required: false,
                              type: "text",
                            },
                          }),
                          _vm._v(" "),
                          _c("b-col", { attrs: { cols: "4" } }),
                          _vm._v(" "),
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-8",
                            attrs: {
                              "form-context": _vm.externalFormContext,
                              label: "Kommentar",
                              property: "comment",
                              required: false,
                              type: "textarea",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }